import { type CustomFieldAssociation } from '../../models/customFieldAssociation';
import {
  addExpenseCategoryToCustomFieldAssociations,
  removeExpenseCategoryFromCustomFieldAssociations,
} from '../../models/expenseCategory';

type UseBudgetTrackingExpenseCategoryInputs = {
  expenseCategoryCustomFieldId?: string;
  customFieldAssociations?: CustomFieldAssociation[];
};

type UseBudgetTrackingExpenseCategoryOutputs = {
  expenseCategoryId?: string | null;
  changeExpenseCategory: (
    newExpenseCategory:
      | {
          id: string;
          name: string;
        }
      | undefined,
  ) => CustomFieldAssociation[];
};

export const useBudgetTrackingExpenseCategory = ({
  expenseCategoryCustomFieldId,
  customFieldAssociations = [],
}: UseBudgetTrackingExpenseCategoryInputs): UseBudgetTrackingExpenseCategoryOutputs => {
  const [, expenseCategoryCustomField] =
    removeExpenseCategoryFromCustomFieldAssociations({
      customFieldAssociations,
      expenseCategoryCustomFieldId,
    });

  const expenseCategoryId = expenseCategoryCustomField?.customFieldValueId;

  const changeExpenseCategory = (
    newExpenseCategory: { id: string; name: string } | undefined,
  ): CustomFieldAssociation[] => {
    let [newCustomFieldAssociations] =
      removeExpenseCategoryFromCustomFieldAssociations({
        customFieldAssociations,
        expenseCategoryCustomFieldId,
      });

    if (newExpenseCategory?.id) {
      newCustomFieldAssociations = addExpenseCategoryToCustomFieldAssociations({
        isExpenseCategoriesFeatureEnabled: true,
        customFieldAssociations: newCustomFieldAssociations,
        expenseCategoryCustomFieldId,
        expenseCategoryId: newExpenseCategory.id,
        expenseCategoryValue: newExpenseCategory.name,
      });
    }

    return newCustomFieldAssociations;
  };

  return {
    expenseCategoryId,
    changeExpenseCategory,
  };
};
